export default "__VITE_ASSET__DpZ0BAM8__"